module.exports = ":host ::ng-deep .masterPageBody {\n  height: 100vh; }\n"